
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      rate: 0,
      stepper: null,
      balances: {
        olimp: {
          value: 0,
          currency: ''
        },
        fanbattle: {
          value: 0,
          currency: ''
        }
      }
    };
  },
  methods: {
    close() {
      this.$app.popup.close();
    },
    calculateRate() {
      this.$setState({ rate: Math.ceil(this.stepper.value * this.$root.params.profile.currency.rate) });
    },
    updateNavbarAfterHeight: function (value) {
      setTimeout(() => {
        document.documentElement.style.setProperty('--navbar-after-height', value);
      }, 100);
    },
    focusStepperValue() {
      if (this.stepper.value != 0) {
        this.stepper.$valueEl[0].value = this.stepper.value;
      } else {
        this.stepper.$valueEl[0].value = '';
      }
      this.calculateRate();
    },
    blurStepperValue() {
      if (this.stepper.value < 1)
        this.stepper.value = 1;
      this.stepper.$valueEl[0].value = this.stepper.value + ` ${ this.$root.params.profile.balance.olimp.currency }`;
      this.calculateRate();
    },
    changeStepperValue(e) {
      this.stepper.setValue(e.target.value);
      this.calculateRate();
    },
    inputStepperValue(e) {
      if (e.target.value == 0) {
        this.stepper.$valueEl[0].value = '';
      }
    },
    minus(e) {
      let r = this.stepper.value - 100;
      if (r <= 1) {
        e.target.closest('.c-stepper-button-minus').classList.add('disabled');
        this.stepper.$valueEl[0].value = 1 + ` ${ this.$root.params.profile.balance.olimp.currency }`;
        this.stepper.setValue(1);
      } else {
        this.stepper.$valueEl[0].value = r + ` ${ this.$root.params.profile.balance.olimp.currency }`;
        this.stepper.setValue(r);
      }
      this.calculateRate();
    },
    plus(e) {
      document.querySelector('.c-stepper-button-minus').classList.remove('disabled');
      let r = this.stepper.value + 100;
      this.stepper.$valueEl[0].value = r + ` ${ this.$root.params.profile.balance.olimp.currency }`;
      this.stepper.setValue(r);
      this.calculateRate();
    },
    submit: function () {
      const _this = this;
      if (this.stepper.value == 0) {
        _this.$app.dialog.alert('Сумма не может быть равна 0');
        return false;
      }
      this.$router.navigate({
        name: 'increase-details',
        query: { 'amount': _this.stepper.value }
      });
    },
    createSteper() {
      const _this = this;
      this.stepper = this.$f7.stepper.create({
        el: '#stepper',
        valueEl: '#stepper-value',
        min: 0,
        max: 9999999,
        step: 1,
        value: 100,
        formatValue: function (value) {
          if (_this.stepper && _this.stepper.$valueEl[0].classList.contains('input-focused')) {
            return value;
          }
          return value + ` ${ _this.$root.params.profile.balance.olimp.currency }`;
        }
      });
      this.stepper.$valueEl[0].value = 100 + ` ${ _this.$root.params.profile.balance.olimp.currency }`;
      this.calculateRate();
    },
    initBalances() {
      this.$setState({
        balances: {
          olimp: {
            value: this.$root.params.profile.balance.olimp.value,
            currency: this.$root.params.profile.balance.olimp.currency
          },
          fanbattle: {
            value: this.$root.params.profile.balance.coins.value,
            currency: this.$root.params.profile.balance.coins.currency
          }
        }
      });
    }
  },
  on: {
    pageInit: function () {
      this.createSteper();
      this.initBalances();
    },
    pageAfterIn: function () {
      if (localStorage.getItem('update-profile') === 'true') {
        this.$router.back();
      }
    },
    pageBeforeOut: function () {
      this.updateNavbarAfterHeight('0px');
    },
    pageBeforeIn: function () {
      this.updateNavbarAfterHeight('1px');
    }
  },
  id: 'f6996b740d',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page">\n        <div class="navbar">\n            <div class="navbar-inner">\n                <div class="left">\n                    <a href="#" @click="close" class="link icon-only">\n                        <i class="icon icon-close"></i>\n                    </a>\n                </div>\n                <div class="title">Перевод между счетами</div>\n            </div>\n        </div>\n\n        <div class="page-content increase-balance">\n            <div class="block no-margin-vertical">\n                <div class="balances__wrapper">\n                    <div class="balance-row">\n                        <div class="app-icon olimp"></div>\n                        <div class="app-name">\n                            <span>Счет списания</span>\n                            <span>Olimp</span>\n                        </div>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.balances, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.balances, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="app-balance">';
              r += Template7Helpers.formatPrice.call(ctx_3, ctx_3.olimp.value, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += ' ';
              r += c(ctx_3.olimp.currency, ctx_3);
              r += '</div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                    <div class="separator">\n                        <hr>\n                    </div>\n                    <div class="balance-row">\n                        <div class="app-icon fanbattle"></div>\n                        <div class="app-name">\n                            <span>Счет зачисления</span>\n                            <span>Fanbattle</span>\n                        </div>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.balances, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.balances, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="app-balance">';
              r += Template7Helpers.formatPrice.call(ctx_3, ctx_3.fanbattle.value, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += ' ';
              r += c(ctx_3.fanbattle.currency, ctx_3);
              r += '</div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n                <div class="input__wrapper">\n                    <div class="stepper stepper-large stepper-fill stepper-init" id="stepper">\n                        <div class="c-stepper-button-minus disabled" @click="minus">\n                            <i class="icon"></i>\n                        </div>\n                        <div class="stepper-input-wrap">\n                            <input\n                                id="stepper-value"\n                                type="tel"\n                                pattern="[0-9.]+"\n                                inputmode="decimal"\n                                value="100"\n                                min=""\n                                max="9999999"\n                                @focus="focusStepperValue"\n                                @blur="blurStepperValue"\n                                @change="changeStepperValue"\n                                @input="inputStepperValue"\n                            />\n                            <span>СУММА</span>\n                        </div>\n                        <div class="c-stepper-button-plus" @click="plus">\n                            <i class="icon"></i>\n                        </div>\n                    </div>\n                    <!--            <span class="hint">Нажмите на сумму, чтобы ввести вручную</span>-->\n                    <div class="commission-hint__wrapper">\n                        <span class="commission-hint">Введите сумму зачисления</span>\n<!--                        <span class="commission">';
      r += c(ctx_1.rate, ctx_1);
      r += ' ';
      r += c(ctx_1.balances.olimp.currency, ctx_1);
      r += '</span>-->\n                    </div>\n                </div>\n                <div class="action_wrapper">\n                    <button @click="submit">Рассчитать</button>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    .icon-close {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.6159 12.0001L19.6649 5.95111C20.1117 5.50426 20.1117 4.78199 19.6649 4.33514C19.218 3.88829 18.4958 3.88829 18.0489 4.33514L12 10.3842L5.95107 4.33514C5.50423 3.88829 4.78197 3.88829 4.33513 4.33514C3.88829 4.78199 3.88829 5.50426 4.33513 5.95111L10.3841 12.0001L4.33513 18.0492C3.88829 18.496 3.88829 19.2183 4.33513 19.6651C4.55798 19.888 4.85054 20 5.1431 20C5.43566 20 5.72822 19.888 5.95107 19.6651L12 13.6161L18.0489 19.6651C18.2718 19.888 18.5643 20 18.8569 20C19.1495 20 19.442 19.888 19.6649 19.6651C20.1117 19.2183 20.1117 18.496 19.6649 18.0492L13.6159 12.0001Z' fill='white'/%3E%3C/svg%3E%0A");
    }
    .increase-balance {

    }

    .increase-balance .block {
        padding-top: 22.5px;
    }

    .increase-balance .balances__wrapper {
        height: auto;
        border-radius: 12px;
        position: relative;
    }

    .increase-balance .balances__wrapper .balance-row {
        background-color: #FFFFFF;
        width: calc(100% - 24px);
        display: flex;
        align-items: center;
        padding: 9px 12px;
        justify-content: space-between;
    }

    .increase-balance .balances__wrapper .balance-row .app-name {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: 11px;
    }

    .increase-balance .balances__wrapper .balance-row .app-name span:nth-child(1) {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #818E95;

    }
    .increase-balance .balances__wrapper .balance-row .app-name span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 19px;
        letter-spacing: -0.41px;
        color: #445058;
    }

    .increase-balance .balances__wrapper .balance-row .app-balance, .sum {
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.41px;
        color: #445058;
    }

    .increase-balance .balances__wrapper .balance-row:nth-child(1) {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }

    .increase-balance .balances__wrapper .balance-row .app-icon {
        width: 38px;
        height: 38px;
        display: block;
    }

    .increase-balance .balances__wrapper .balance-row .app-icon.olimp {
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='38' height='38' rx='4.75' fill='%23121212'/%3E%3Cpath d='M19.0014 5.4668C16.3249 5.46651 13.7085 6.2599 11.483 7.74664C9.25755 9.23337 7.52291 11.3467 6.49849 13.8193C5.47407 16.2919 5.20589 19.0127 5.72786 21.6378C6.24983 24.2628 7.5385 26.6741 9.43092 28.5667C11.3233 30.4593 13.7345 31.7482 16.3594 32.2705C18.9844 32.7927 21.7053 32.5248 24.178 31.5007C26.6507 30.4765 28.7642 28.7421 30.2512 26.5168C31.7381 24.2914 32.5318 21.6751 32.5318 18.9987C32.5318 15.4101 31.1063 11.9684 28.5689 9.43071C26.0315 6.89302 22.59 5.46718 19.0014 5.4668Z' fill='%23771610'/%3E%3Cpath d='M23.5986 12.0454C23.7301 12.045 23.8615 12.0522 23.9921 12.0669C24.0423 12.1671 24.1004 12.2632 24.1659 12.3542C24.4535 12.7707 24.8918 13.0591 25.3881 13.1584C24.5924 13.2145 23.9892 12.9401 23.5986 12.0454ZM23.8858 11.8472C23.7953 11.6197 23.7307 11.3826 23.6934 11.1406C23.1304 10.3219 21.8033 10.2516 20.3025 10.7097C21.2317 12.0124 22.4913 12.2938 23.893 11.8472H23.8858ZM21.6439 10.1798C22.362 10.1266 22.9681 10.2401 23.4104 10.5187C23.4937 10.5726 23.5724 10.6332 23.646 10.6997C23.6337 10.4636 23.6385 10.227 23.6603 9.99162C23.1218 9.31373 22.1308 8.95755 20.7118 8.95899C20.9285 9.43174 21.2497 9.84914 21.6511 10.1798H21.6439ZM25.378 12.8899C25.6709 13.2106 25.9857 13.5105 26.3202 13.7875C26.2398 13.6098 26.1712 13.427 26.1148 13.2403C25.9443 13.1026 25.7813 12.9559 25.6265 12.8008C26.1162 11.6519 25.4656 10.5589 23.9993 9.45879C23.7063 11.0099 24.0725 12.5653 25.3852 12.8899H25.378ZM27.3758 16.3368C27.416 16.3824 27.4534 16.4303 27.4878 16.4804C27.4911 16.2765 27.5147 16.0735 27.5582 15.8743C27.5556 15.6346 27.5068 15.3976 27.4146 15.1763C27.0634 14.8877 26.76 14.5455 26.5155 14.1623C26.0162 13.8595 25.4641 13.6538 24.8883 13.5563C25.0664 15.2409 26.1723 16.3238 27.383 16.3368H27.3758ZM27.6975 15.0686C27.6936 15.1645 27.6975 15.2605 27.709 15.3558C27.8091 15.0884 27.9316 14.83 28.0752 14.5832C28.3524 13.4888 27.9216 12.1962 26.0128 11.4824C26.3345 13.4155 26.5529 14.125 27.7047 15.0686H27.6975ZM27.8986 17.378C28.1006 17.5879 28.2806 17.8179 28.4357 18.0645C29.4669 17.322 29.5244 15.7465 28.723 14.0719C27.7162 15.4635 27.5812 16.4631 27.9058 17.378H27.8986ZM26.4897 16.5321C26.7396 19.1503 26.9421 19.7793 28.1427 20.7358C28.0629 20.0297 28.1704 19.3149 28.4544 18.6634C28.1829 17.9625 27.5711 17.2933 26.4968 16.5321H26.4897ZM29.6192 17.3565C28.1829 18.998 28.2189 20.4946 28.654 21.7728C28.5227 21.883 28.3779 21.9761 28.2232 22.05L28.1384 22.0945C28.2153 21.9401 28.282 21.7808 28.3381 21.6177C28.2686 21.3823 28.2158 21.1424 28.1801 20.8996C28.091 21.7125 27.6056 22.5167 27.2035 22.995C27.4409 22.8323 27.6906 22.6882 27.9503 22.5641C28.0937 22.4482 28.2438 22.3408 28.3998 22.2424C28.5651 22.1399 28.7226 22.0251 28.8709 21.8992C29.8245 21.6277 30.5943 19.528 29.6192 17.3565ZM26.4049 23.6556C26.5213 23.5379 26.6448 23.423 26.7769 23.3124C26.861 23.1219 26.9283 22.9244 26.978 22.7221C27.5625 21.8202 27.3054 20.6468 26.3389 19.0914C25.6208 20.71 25.9367 22.2396 26.6405 22.8428C26.5711 23.0215 26.4875 23.1944 26.3906 23.3598C26.3977 23.4603 26.4035 23.5594 26.4035 23.6556H26.4049ZM25.6337 25.5802C25.5434 25.5942 25.4548 25.6178 25.3694 25.6505C25.3938 25.089 25.6954 24.4542 26.1995 23.8754C26.2212 23.236 26.1077 22.5993 25.8663 22.0069C24.6944 23.1113 24.5738 24.2761 25.0779 25.6333C24.954 25.7962 24.8217 25.9525 24.6815 26.1015C24.8553 26.0594 25.0347 26.0458 25.2129 26.0613C25.3871 25.9284 25.5857 25.8308 25.7974 25.774C27.495 26.0914 28.2548 25.3848 29.2644 22.4191C27.1776 22.8054 25.7414 24.4254 25.6322 25.5802H25.6337ZM23.4104 27.4975C24.4574 28.3362 25.4384 28.2156 26.5055 26.7952C24.894 25.8631 24.2176 26.3471 23.409 27.4975H23.4104ZM22.0346 26.8814C22.4614 26.9224 22.8709 27.0706 23.2252 27.3122C23.4526 26.9711 23.7306 26.6665 24.0495 26.4088C24.3257 25.771 24.5155 25.0991 24.614 24.4111C23.2726 24.8147 22.4094 25.7152 22.0331 26.8814H22.0346ZM20.4203 27.5693C20.0782 27.6902 19.7566 27.8626 19.4666 28.0806L19.1794 28.273C19.2885 28.3391 19.4049 28.4052 19.5284 28.4712C19.7644 28.269 20.0134 28.0823 20.2738 27.9125C21.0551 28.7843 22.474 28.9179 23.8729 28.2817C22.8762 26.979 21.6051 26.8282 20.4188 27.5693H20.4203ZM18.4354 28.6953C17.8585 28.9741 17.2383 29.1529 16.6014 29.2238L16.4578 29.241L17.2505 29.8988L17.2821 29.8916C17.8566 29.748 18.3722 29.4019 18.8476 29.0299L18.5704 28.8001L18.4354 28.6953Z' fill='%23FCC341'/%3E%3Cpath d='M9.1392 17.7945C8.43546 16.9745 8.47423 15.5771 9.17797 14.1006C9.48528 14.5082 9.73961 14.9532 9.93486 15.4248C9.87303 15.9018 9.73125 16.365 9.51548 16.7949C9.4408 16.9615 9.37186 17.1181 9.31154 17.2818C9.25122 17.4455 9.18803 17.6351 9.1392 17.7945ZM14.3009 27.6856C14.2779 27.6598 14.1573 27.5664 14.0582 27.4831C13.6293 27.1122 13.2325 26.7058 12.8719 26.2681L12.803 26.1805C12.3922 26.1475 11.9154 26.2509 11.3409 26.5309C11.9154 27.8882 13.2984 28.2903 14.334 27.7216L14.3009 27.6856ZM15.019 12.2623C14.6828 12.1899 14.338 12.1662 13.995 12.1919C13.9577 12.258 13.9175 12.3226 13.8744 12.3844C13.7272 12.5962 13.5397 12.7769 13.3226 12.9162C13.1055 13.0554 12.863 13.1505 12.6091 13.1958C13.557 13.4429 14.3383 13.2461 15.019 12.2623ZM15.0707 12.0052L15.3422 12.0598C16.1464 11.9794 16.8645 11.5643 17.4491 10.7399C17.2164 10.6696 16.9895 10.6107 16.7669 10.5661C16.1393 11.1191 15.3307 11.3934 14.2894 11.4279C14.2499 11.5973 14.1961 11.763 14.1286 11.9234C14.4447 11.9139 14.7609 11.9414 15.0707 12.0052ZM17.574 8.9375C16.0402 9.00644 14.9702 9.42868 14.3842 10.164C14.4066 10.4964 14.3922 10.8301 14.3411 11.1593C15.8161 11.1033 16.9019 10.5044 17.574 8.9375ZM11.924 13.2576C11.8733 13.4282 11.8124 13.5956 11.7416 13.7588L11.8163 13.7244C12.1124 13.472 12.3925 13.2015 12.655 12.9143C13.9677 12.5883 14.334 11.0329 14.0338 9.48326C12.5674 10.5819 11.9168 11.6749 12.4066 12.8239C12.2545 12.9797 12.0933 13.1264 11.924 13.2633V13.2576ZM9.70075 16.8567C9.62607 17.0204 9.55713 17.1755 9.49969 17.335C9.39915 17.6107 9.3216 17.8563 9.26271 18.076C9.36465 18.2433 9.45673 18.4165 9.53846 18.5945C9.59447 18.3073 9.67347 17.9655 9.78693 17.5777C9.92094 17.3173 10.0791 17.0702 10.2594 16.8395C10.3671 16.6675 10.4917 16.5068 10.6314 16.3598C11.8594 16.3598 12.9724 15.2754 13.139 13.5822C11.5736 13.8694 10.2925 14.7412 10.495 16.2176C10.416 16.3181 10.3413 16.423 10.2681 16.5307C10.1948 16.6384 10.1015 16.7691 10.0067 16.8854C10.2178 16.2377 10.4117 15.613 10.3973 15.0413C10.4478 14.9287 10.5079 14.8206 10.5768 14.7182C10.7759 14.4324 11.0292 14.1884 11.3222 14.0001C11.6727 13.4041 11.8278 12.6831 12.0188 11.5112C9.79267 12.3442 9.57724 13.9628 10.1517 15.1376C10.1374 15.8844 9.909 16.3971 9.70075 16.8624V16.8567ZM11.5434 16.4345C10.4375 17.2186 9.81996 17.9051 9.5557 18.629C9.83888 19.2557 9.95752 19.9443 9.90039 20.6296C11.0924 19.6831 11.2949 19.0512 11.5434 16.4402V16.4345ZM9.17797 21.9279C9.29498 22.0287 9.41878 22.1213 9.54852 22.2051C9.93029 22.3316 10.295 22.5048 10.6343 22.7207C10.5348 22.549 10.4544 22.367 10.3944 22.1778C10.1332 21.7373 9.96278 21.249 9.89321 20.7416C9.86377 21.0091 9.81286 21.2737 9.74097 21.533C9.8185 21.7616 9.91456 21.9835 10.0282 22.1965C9.9564 22.152 9.88459 22.1161 9.81709 22.0816C9.66234 22.0072 9.51758 21.9136 9.38623 21.803C9.81709 20.5248 9.85443 19.0282 8.42109 17.3867C7.44448 19.5654 8.22003 21.6594 9.17797 21.9337V21.9279ZM11.7258 19.0081C10.1603 20.766 10.3614 22.0155 11.1327 22.9864C11.147 23.0309 11.1614 23.0755 11.1772 23.1185C11.3713 23.2817 11.5528 23.4593 11.7201 23.6499C11.7201 23.6083 11.7301 23.5652 11.7344 23.5221C11.6212 23.3437 11.5227 23.1564 11.44 22.962C12.2155 22.3071 12.8159 20.6813 11.7258 19.0139V19.0081ZM12.3003 25.7755C12.3606 25.7904 12.4201 25.8086 12.4784 25.8301C12.2381 25.5966 12.047 25.3173 11.9165 25.0087C11.786 24.7001 11.7187 24.3685 11.7186 24.0334C11.3393 23.5431 10.8663 23.1331 10.3271 22.8274C9.78782 22.5216 9.19314 22.3262 8.57764 22.2525C9.65623 25.4222 10.4591 26.1446 12.2931 25.7812L12.3003 25.7755ZM12.8934 25.8373C13.2166 26.3028 13.6006 26.723 14.0352 27.0868C13.8935 26.8213 13.7776 26.5428 13.6891 26.2552C13.491 26.0462 13.3068 25.8246 13.1376 25.5917C13.5814 24.3436 13.4478 23.242 12.3735 22.1663C11.6669 23.8955 11.9542 25.145 12.8863 25.843L12.8934 25.8373ZM16.0531 26.8886C15.7256 25.754 14.9314 24.8463 13.6604 24.3738C13.6905 25.7008 14.0352 26.7708 14.6255 27.4659C15.0296 27.1324 15.5265 26.9313 16.0488 26.89L16.0531 26.8886ZM21.4446 29.2468C20.0084 29.0745 19.1984 28.5517 18.5478 28.1309C18.2961 27.9574 18.0304 27.8051 17.7536 27.6756C16.5313 26.8412 15.2043 26.9575 14.176 28.3047C15.5619 28.938 16.9708 28.8116 17.755 27.9585C18.0307 28.1395 18.3165 28.3693 18.6167 28.6077C19.2558 29.1262 19.9811 29.7121 20.771 29.9146L20.8041 29.9232L21.5968 29.2655L21.4446 29.2468Z' fill='%23FCC341'/%3E%3Cpath d='M19.0014 4.75C16.183 4.74972 13.4278 5.58522 11.0842 7.15086C8.74059 8.7165 6.9139 10.9419 5.83514 13.5458C4.75637 16.1496 4.47396 19.0148 5.02364 21.7792C5.57332 24.5435 6.93039 27.0827 8.92323 29.0758C10.9161 31.0688 13.4552 32.4261 16.2194 32.9761C18.9837 33.526 21.849 33.2439 24.4529 32.1654C27.0568 31.0869 29.2825 29.2605 30.8483 26.917C32.4142 24.5736 33.25 21.8184 33.25 19C33.25 15.2209 31.7489 11.5966 29.0768 8.92424C26.4047 6.25188 22.7805 4.75038 19.0014 4.75ZM19.0014 31.7075C16.4877 31.7078 14.0304 30.9626 11.9402 29.5663C9.84999 28.1699 8.22083 26.185 7.25874 23.8627C6.29665 21.5404 6.04485 18.9849 6.53518 16.5195C7.02551 14.0541 8.23595 11.7894 10.0134 10.012C11.7909 8.23451 14.0555 7.02407 16.521 6.53374C18.9864 6.04341 21.5419 6.29521 23.8642 7.2573C26.1865 8.21938 28.1713 9.84854 29.5677 11.9387C30.9641 14.0289 31.7092 16.4863 31.709 19C31.7086 22.3701 30.3696 25.6021 27.9866 27.9851C25.6035 30.3682 22.3716 31.7071 19.0014 31.7075Z' fill='%23FCC341'/%3E%3C/svg%3E%0A");
    }

    .increase-balance .balances__wrapper .balance-row .app-icon.fanbattle {
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='38' height='38' rx='4.75' fill='%23007AFF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M28.0906 10.8351C27.2016 10.0212 25.9105 9.4521 24.5484 9.07097C23.1537 8.68073 21.5407 8.44787 19.882 8.39719C16.6149 8.29738 12.892 8.89929 10.2297 10.7018L10.2276 10.7032L10.2255 10.7046C9.93295 10.9041 9.79446 11.1569 9.76674 11.2075L9.7646 11.2114C9.71628 11.299 9.68731 11.3728 9.67414 11.4079C9.64631 11.482 9.63036 11.5428 9.62431 11.5664C9.61007 11.622 9.60116 11.6695 9.59687 11.6932C9.58696 11.748 9.57886 11.8048 9.57231 11.8562C9.55863 11.9635 9.54482 12.1017 9.533 12.266C9.50923 12.5965 9.4919 13.056 9.50391 13.6196C9.52794 14.7462 9.66963 16.3073 10.1222 18.0976C11.0303 21.6895 13.1908 26.1966 18.115 29.9205L18.1348 29.9359C18.155 29.9514 18.1827 29.9723 18.2154 29.9959L19.1252 30.6523L19.9972 29.9498L20.0026 29.9461L20.0244 29.9296C24.9572 26.2041 27.1186 21.694 28.0265 18.0997C28.4786 16.3098 28.62 14.749 28.6444 13.6227C28.6566 13.0591 28.6396 12.6001 28.6165 12.2705C28.605 12.1064 28.5917 11.9697 28.5788 11.8646C28.5726 11.8138 28.5653 11.7604 28.5567 11.71C28.553 11.6879 28.5458 11.6469 28.5348 11.5995C28.53 11.5792 28.5181 11.529 28.498 11.4674C28.4884 11.4384 28.4677 11.3776 28.4337 11.3042L28.432 11.3005C28.4141 11.2612 28.3134 11.0403 28.0941 10.8383L28.0924 10.8367L28.0906 10.8351ZM12.4492 13.5566C12.4429 13.2605 12.4464 13.0052 12.4542 12.7967C13.88 12.0105 15.7369 11.5513 17.6896 11.3974V25.6462C14.9294 22.8644 13.6045 19.8508 12.978 17.3725C12.5888 15.833 12.4693 14.4981 12.4492 13.5566ZM20.4588 25.6493C23.2203 22.8674 24.5446 19.8538 25.1706 17.3753C25.5594 15.8361 25.6787 14.5011 25.6991 13.5587C25.7065 13.219 25.7009 12.9325 25.6909 12.7084C25.2492 12.4328 24.6044 12.1518 23.7561 11.9145C22.7959 11.6458 21.6651 11.4582 20.4588 11.3799V25.6493Z' fill='white'/%3E%3C/svg%3E%0A");
    }

    .increase-balance .balances__wrapper hr {
        margin: 0px;
        height: 1px;
        border: none;
        background: #CFD6DB;
    }

    .increase-balance .balances__wrapper .icon__wrapper {
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        position: absolute;
        background: #FFF;
        padding: 0px 4px;
    }

    .increase-balance .balances__wrapper .icon-arrow-down {
        background: url("/static/icons/arrow-down.svg") no-repeat;
        width: 24px;
        height: 24px;
        display: block;
    }

    .increase-balance .balances__wrapper .balance-row:nth-child(3) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    .increase-balance .balances__wrapper + .input__wrapper {
        margin-top: 32px;
    }

    .increase-balance .input__wrapper {
        height: auto;
    }

    .increase-balance .input__wrapper .stepper {
        width: 100%;
        height: 56px;
    }

    .increase-balance .input__wrapper .stepper .stepper-input-wrap {
        width: 100%;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-minus {
        width: 76px;
        border: 1px solid #CFD6DB;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        background-color: #FFFFFF;
        color: var(--f7-stepper-button-text-color, var(--f7-theme-color));
        line-height: calc(var(--f7-stepper-height) - var(--f7-stepper-border-width, 0px));
        text-align: center;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex-shrink: 0;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-minus:active {
        background-color: rgba(var(--f7-theme-color-rgb), .15);
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-plus:active {
        background-color: rgba(var(--f7-theme-color-rgb), .15);
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-minus::after, .c-stepper-button-minus::before,
    .c-stepper-button-plus::after, .c-stepper-button-plus::before {
        content: none;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-minus .icon {
        background: url("/static/icons/minus.svg") no-repeat;
        width: 32px;
        height: 32px;
        display: block;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-plus .icon {
        background: url("/static/icons/plus.svg") no-repeat;
        width: 32px;
        height: 32px;
        display: block;
    }

    .increase-balance .input__wrapper .stepper .stepper-input-wrap {
        border-top: 1px solid #CFD6DB;
        border-bottom: 1px solid #CFD6DB;
        background-color: #FFF;
        color: #000;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .increase-balance .input__wrapper .stepper .stepper-input-wrap input {
        width: 100%;
        height: auto;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 25px;
        letter-spacing: 0.38px;
        color: #445058;
    }

    .increase-balance .input__wrapper .stepper .stepper-input-wrap span {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .increase-balance .input__wrapper .stepper .stepper-input-wrap input + span {
        margin-top: 2px;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-minus::before, .c-stepper-button-minus::after {
        background-color: var(--f7-theme-text);
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-plus {
        width: 76px;
        border: 1px solid #CFD6DB;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        background-color: #FFFFFF;
        color: var(--f7-stepper-button-text-color, var(--f7-theme-color));
        line-height: calc(var(--f7-stepper-height) - var(--f7-stepper-border-width, 0px));
        text-align: center;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex-shrink: 0;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
    }

    .increase-balance .input__wrapper .stepper .c-stepper-button-plus::before, .c-stepper-button-plus::after {
        background-color: var(--f7-theme-text);
    }

    .increase-balance .input__wrapper .hint {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 14px;
        letter-spacing: 0.07px;
        color: #818E95;
        margin-top: 4px;
        display: block;
    }

    .increase-balance .input__wrapper + .action_wrapper {
        margin-top: 24px;
    }

    .increase-balance .action_wrapper button {
        height: 46px;
        background: #32BF61;
        border-radius: 7px;
        border: none;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 20px;
        color: #FFFFFF;
    }

    .increase-balance .commission-hint__wrapper {
        display: flex;
        justify-content: space-between;
    }

    .increase-balance .commission-hint, .commission {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 14px;
        letter-spacing: 0.07px;
        color: #818E95;
        margin-top: 4px;
        display: block;
    }
`,
  styleScoped: false
};
    